import { render } from "./ArtistDetail.vue?vue&type=template&id=1fd073af&scoped=true"
import script from "./ArtistDetail.vue?vue&type=script&lang=js"
export * from "./ArtistDetail.vue?vue&type=script&lang=js"

import "./artists.scss?vue&type=style&index=0&id=1fd073af&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd073af"]])

export default __exports__